import { ApiResponse } from 'apisauce';
import { apiClientWithoutHandler } from 'src/js/api';
import { APIPath } from 'src/js/api/route-path-index';
import { mapServices } from 'src/js/mapper/services-mapper';
import { mapUpdateServices } from 'src/js/mapper/update-services-mapper';
import { createUpdateServicesRequest } from 'src/js/model/api/request/factory/update-services-request-factory';
import { ServicesResponse } from 'src/js/model/api/response/services-response';
import { UpdateServicesResponse } from 'src/js/model/api/response/update-services-response';
import { Service } from 'src/js/model/service';
import { Services } from 'src/js/model/services';

export const fetchServices = (): Promise<ApiResponse<Services>> => {
  return apiClientWithoutHandler.genericController.get<ServicesResponse>(APIPath.services.status).then((res) => {
    if (res.ok && res.data) {
      return { ...res, data: mapServices(res.data) };
    }
    return res as unknown as ApiResponse<Services>;
  });
};

export const updateService = (service: Service, value: boolean): Promise<ApiResponse<Services>> => {
  return apiClientWithoutHandler.genericController
    .put<UpdateServicesResponse>(APIPath.services.status, createUpdateServicesRequest(service, value))
    .then((res) => {
      if (res.ok && res.data) {
        return { ...res, data: mapUpdateServices(res.data) };
      }
      return res as unknown as ApiResponse<Services>;
    });
};
